import { render, staticRenderFns } from "./sealDialog.vue?vue&type=template&id=71b2e412&"
import script from "./sealDialog.vue?vue&type=script&lang=js&"
export * from "./sealDialog.vue?vue&type=script&lang=js&"
import style0 from "./sealDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports